import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pt/",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet/",
    element: <ArticlePage slug="cssbuy-spreadsheet-complete-guide" />,
  },
  {
    path: "/cssbuy-review/",
    element: <ArticlePage slug="cssbuy-review-2026" />,
  },
  {
    path: "/cssbuy-shipping-cost/",
    element: <ArticlePage slug="cssbuy-shipping-cost-guide" />,
  },
  {
    path: "/cssbuy-qc/",
    element: <ArticlePage slug="cssbuy-qc-guide" />,
  },
  {
    path: "/cssbuy-warehouse/",
    element: <ArticlePage slug="cssbuy-warehouse-guide" />,
  },
  {
    path: "/cssbuy-coupon/",
    element: <ArticlePage slug="cssbuy-coupon-guide" />,
  },
  {
    path: "/cssbuy-discount-code/",
    element: <ArticlePage slug="cssbuy-discount-code-guide" />,
  },
  {
    path: "/is-cssbuy-legit/",
    element: <ArticlePage slug="is-cssbuy-legit" />,
  },
  {
    path: "/cssbuy-fees/",
    element: <ArticlePage slug="cssbuy-fees-guide" />,
  },
  {
    path: "/cssbuy-buying-guide/",
    element: <ArticlePage slug="cssbuy-buying-guide" />,
  },
  {
    path: "/guides/",
    element: <Navigate to="/cssbuy-spreadsheet/" replace />,
  },
  {
    path: "/finds/",
    element: <Navigate to="/cssbuy-spreadsheet/" replace />,
  },
  {
    path: "/categories/",
    element: <Navigate to="/cssbuy-spreadsheet/" replace />,
  },
  {
    path: "/shipping/",
    element: <Navigate to="/cssbuy-shipping-cost/" replace />,
  },
  {
    path: "/qc/",
    element: <Navigate to="/cssbuy-qc/" replace />,
  },
  {
    path: "/safety/",
    element: <Navigate to="/is-cssbuy-legit/" replace />,
  },
  {
    path: "/reviews/",
    element: <Navigate to="/cssbuy-review/" replace />,
  },
  {
    path: "/comparisons/",
    element: <Navigate to="/cssbuy-review/" replace />,
  },
  {
    path: "/about/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/contact/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/privacy-policy/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/terms/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/disclaimer/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/editorial-policy/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;